export default "__VITE_ASSET__DQbMo$r2__"